import _ from "underscore";
import { TObjectFieldClass } from "../types/api/APIClassTypes";

const dataIrrelevantProps = [
    "allowMultiSelection",
    "hoverButton",
    "isLayerShown",
    "topLeftButton",
    "user",
] as const;

// Only a subset of these should affect data loading!
const relevantProps = [
    "allowMultiSelection",
    "data",
    "hoverButton",
    "isLayerShown",
    "selectedFluffyItem",
    "selectedType",
    "subtypes",
    "topLeftButton",
    "user",
    "staticObjects",
    "reservationIds",
    "occuringObjects",
    "relatedObject",
    "excludeObjects",
] as const;

const getChangedProps = (nextProps, currentProps, propList: readonly string[]) => {
    const changedProps: string[] = [];
    propList.forEach((prop) => {
        if (!_.isEqual(nextProps[prop], currentProps[prop])) {
            changedProps.push(prop);
        }
    });
    return changedProps;
};

const errorCorrectLoadedSettings = (loadedSettings) => {
    let result = loadedSettings.map((loadedSetting) => {
        let selectedCategories = { ...loadedSetting.settings.selectedCategories };
        Object.keys(selectedCategories).forEach((key) => {
            let selectedValues = selectedCategories[key];
            selectedCategories[key] = selectedValues.map((value) =>
                Array.isArray(value) ? value.flat() : value
            );
        });
        return { ...loadedSetting, settings: { ...loadedSetting.settings, selectedCategories } };
    });
    return result;
};

const RelationFilter = {
    INACTIVE: { id: 0 },
    ACTIVE: { id: 1 },
} as const;

const getUpdatedObjectStore = (
    newObjects,
    firstIndex: number,
    totalNumber: number,
    currentObjects
): TObjectFieldClass[] => {
    const total = firstIndex === 0 ? totalNumber : currentObjects.length;
    let objectStore: TObjectFieldClass[] =
        firstIndex === 0 ? [].concat(newObjects) : currentObjects ? [].concat(currentObjects) : [];
    objectStore.length = total;

    for (let i = 0; i < newObjects.length; i++) {
        objectStore[firstIndex + i] = newObjects[i];
    }

    return objectStore;
};

type NamingColumn = {
    id: number;
    name?: string;
    primary?: boolean;
};

const getNamingColumn = <T extends { primary?: boolean } = NamingColumn>(
    columns: readonly (T | null | undefined)[]
): T | undefined => columns.find((column): column is T => Boolean(column?.primary));

export default {
    dataIrrelevantProps,
    relevantProps,
    getChangedProps,
    errorCorrectLoadedSettings,
    RelationFilter,
    getUpdatedObjectStore,
    getNamingColumn,
};
